import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { isNative } from './is-native';

const PREF_KEY = 'mucka_haptics_enabled';

// User can disable haptics in mobile settings. Default: on.
function enabled(): boolean {
  if (!isNative()) return false;
  if (typeof localStorage === 'undefined') return true;
  return localStorage.getItem(PREF_KEY) !== 'false';
}

export function setEnabled(value: boolean) {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(PREF_KEY, value ? 'true' : 'false');
}

export function isEnabled(): boolean {
  return enabled();
}

export async function tap() {
  if (!enabled()) return;
  try { await Haptics.impact({ style: ImpactStyle.Light }); } catch {}
}

export async function press() {
  if (!enabled()) return;
  try { await Haptics.impact({ style: ImpactStyle.Medium }); } catch {}
}

export async function thud() {
  if (!enabled()) return;
  try { await Haptics.impact({ style: ImpactStyle.Heavy }); } catch {}
}

export async function success() {
  if (!enabled()) return;
  try { await Haptics.notification({ type: NotificationType.Success }); } catch {}
}

export async function warning() {
  if (!enabled()) return;
  try { await Haptics.notification({ type: NotificationType.Warning }); } catch {}
}

export async function error() {
  if (!enabled()) return;
  try { await Haptics.notification({ type: NotificationType.Error }); } catch {}
}

export async function selection() {
  if (!enabled()) return;
  try { await Haptics.selectionStart(); } catch {}
}
